import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../api/api';
import { axios } from '../api/axios';
import MainLoading from '../view/components/loading/main-loading';
import { useAlert } from 'react-alert';

export const MemberContext = React.createContext({});

function MemberProvider(props) {
  const [auth, setAuth] = useState({ value: false, status: 0 });
  const [info, setInfo] = useState({});
  const [events, setEvents] = useState({ list: [], unseenCount: 0 });
  const [checked, setChecked] = useState(false);
  const [redirect, setRedirect] = useState(null);
  let history = useHistory();
  const alert = useAlert();
  let interval = useRef(null);
  const intervalTimeout = 10000;

  useEffect(() => {
    if (interval.current) {
      clearInterval(interval.current);
    }

    const handleInterval = () => {
      api.member.auth().then((response) => {
        if (response.auth) {
          if (response.auth.value === false) {
            setEvents({ list: [], unseenCount: 0 });
            if (interval.current) {
              clearInterval(interval.current);
            }

            localStorage.removeItem('member-auth-token');
            axios.defaults.headers.common['Member-Auth-Token'] = '';
          } else {
            if (response.events !== undefined) {
              const { list, unseenCount } = response.events;
              setEvents((prevEvents) => {
                const update = {
                  list: list,
                  unseenCount: unseenCount,
                };

                return { ...prevEvents, ...update };
              });
            }

            if (response.info !== undefined) {
              setInfo(response.info);
            }
          }

          // <Set auth if data changed>
          if (auth.value !== response.auth.value) {
            setAuth(response.auth);
          }
          // </Set auth if data changed>
        }

        setChecked(true);
      });
    };

    if (auth.value) {
      interval.current = setInterval(handleInterval, intervalTimeout);
    } else if (checked === false) {
      handleInterval();
    }

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [auth.value]);

  function login(data) {
    // if member is logged and auth is true then set interval and token.
    if (data.auth.value === true) {
      localStorage.setItem('member-auth-token', data.auth.authToken);
      axios.defaults.headers.common['Member-Auth-Token'] = data.auth.authToken;
    }

    if (data.events !== undefined) {
      const { list, unseenCount } = data.events;
      setEvents((prevEvents) => {
        const update = {
          list: list,
          unseenCount: unseenCount,
        };

        return { ...prevEvents, ...update };
      });
    }

    if (data.info !== undefined) {
      setInfo(data.info);
    }

    setAuth(data.auth);

    if (redirect !== null) {
      history.replace({
        pathname: redirect,
      });

      setRedirect(null);
    }
  }

  function logout() {
    if (interval.current) {
      clearInterval(interval.current);
    }

    api.member.logout().then((response) => {
      if (response.status === 'ok') {
        alert.success('از حساب کاربری خارج شدید.');
        localStorage.removeItem('member-auth-token');
        axios.defaults.headers.common['Member-Auth-Token'] = '';
        setAuth({ value: false, status: 0 });
        setEvents({ list: [], unseenCount: 0 });
      }
    });
  }

  // Event manager => em
  const em = {};
  em.list = events.list;
  em.unseenCount = events.unseenCount;
  em.eventSeen = (eventId) => {
    // <set (seen === 1) for event>
    let _list = events.list;
    for (let i = 0; i < _list.length; i++) {
      if (parseInt(_list[i].id) === parseInt(eventId)) {
        _list[i].seen = 1;
        break;
      }
    }
    setEvents((prevEvents) => {
      const update = {
        list: _list,
      };

      return { ...prevEvents, ...update };
    });
    // </set (seen === 1) for event>

    api.member.eventSeen({ id: eventId }).then((response) => {
      const { status } = response;

      if (status === 'ok') {
        const newUnseenCount = events.unseenCount - 1;
        setEvents((prevEvents) => {
          const update = {
            unseenCount: newUnseenCount,
          };

          return { ...prevEvents, ...update };
        });
      }
    });
  };
  em.eventsSeen = () => {
    if (events.unseenCount > 0) {
      api.member.allEventSeen().then((response) => {
        const { status } = response;

        if (status === 'ok') {
          setEvents((prevEvents) => {
            const update = {
              unseenCount: 0,
            };

            return { ...prevEvents, ...update };
          });
        }
      });
    }
  };
  // --Event manager => em

  // Password recovery manager => prm
  const prm = {};
  [prm.message, prm.setMessage] = useState(null);
  [prm.pending, prm.setPending] = useState(false);
  [prm.form, prm.setForm] = useState('username');
  [prm.destination, prm.setDestination] = useState('');
  prm.reset = () => {
    prm.setForm('username');
    prm.setDestination('');
    prm.setPending(false);
    prm.setMessage(null);
  };
  prm.sendCode = (data) => {
    prm.setPending(true);
    prm.setMessage(null);

    api.member
      .sendPasswordRecoveryCode(data)
      .then((response) => {
        const { status, message, destination } = response;

        if (status === 'ok') {
          prm.setMessage(null);
          prm.setDestination(destination);
          prm.setForm('code');
        } else if (status === 'error') {
          prm.setMessage(message);
        }

        prm.setPending(false);
      })
      .catch(() => {
        prm.setPending(false);
      });
  };
  prm.resendCode = () => {
    prm.setPending(true);

    api.member
      .resendPasswordRecoveryCode()
      .then((response) => {
        const { status, message, reset } = response;

        if (status === 'ok') {
          alert.success(message);
        } else if (status === 'error') {
          alert.error(message);
        }

        if (reset) {
          prm.reset();
        }

        prm.setPending(false);
      })
      .catch(() => {
        prm.setPending(false);
      });
  };
  prm.validateCode = (data) => {
    prm.setPending(true);
    prm.setMessage(null);

    api.member
      .validationPasswordRecoveryCode(data)
      .then((response) => {
        const { status, message, reset } = response;

        if (status === 'ok') {
          prm.setMessage(null);
          prm.setForm('password');
        } else if (status === 'error') {
          if (reset) {
            alert.error(message);
          } else {
            prm.setMessage(message);
          }
        }

        if (reset) {
          prm.reset();
        }

        prm.setPending(false);
      })
      .catch(() => {
        prm.setPending(false);
      });
  };
  prm.changePassword = (data) => {
    prm.setPending(true);
    prm.setMessage(null);

    api.member
      .setNewPassword(data)
      .then((response) => {
        const { status, message, reset } = response;

        if (status === 'ok') {
          alert.success(message);

          history.replace({
            pathname: '/member/login',
          });
        } else {
          if (status === 'error') {
            if (reset) {
              alert.error(message);
            } else {
              prm.setMessage(message);
            }
          }

          if (reset) {
            prm.reset();
          }
        }

        prm.setPending(false);
      })
      .catch(() => {
        prm.setPending(false);
      });
  };
  // --Password recovery manager => prm

  const updateInfo = (key, value) => {
    setInfo((prevState) => {
      const newState = prevState;
      newState[key] = value;

      return { ...prevState, ...newState };
    });
  };

  const memberContext = {
    auth,
    info,
    updateInfo,
    passwordRecovery: prm,
    events: em,
    login,
    logout,
    redirect,
    setRedirect,
  };

  if (checked) {
    return <MemberContext.Provider value={memberContext}>{props.children}</MemberContext.Provider>;
  } else {
    return <MainLoading />;
  }
}

export default MemberProvider;
